export const ADMISSION_DETAILS_UPDATE = 'admissionDetails:update';
export const SHOW_FAMILY_CONTACTS = 'familyContacts:show';
export const ADD_PERSON = 'addPerson';
export const SWITCH_ACTIVE_PERSON = 'switchActivePerson';
export const SHOW_SIDEBAR_COMPONENT = 'SHOW_SIDEBAR_COMPONENT';
export const PREVIOUS_DATE_RANGE_SELECTED = 'PREVIOUS_DATE_RANGE_SELECTED';
export const NEXT_DATE_RANGE_SELECTED = 'NEXT_DATE_RANGE_SELECTED';
export const UPDATE_PROVIDER = 'UPDATE_PROVIDER';
export const CREATE_TASK = 'task:create';
export const UPDATE_TASK = 'task:update';
export const CREATE_GOAL = 'goal:create';
export const UPDATE_GOAL = 'goal:update';